import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import IntlMessages from '../../util/IntlMessages';
import CustomScrollbars from '../../util/CustomScrollbars';


class SidenavContent extends Component {
  componentDidMount() {
    const { history } = this.props;
    const that = this;
    const pathname = `${history.location.pathname}`;// get current path

    const menuLi = document.getElementsByClassName('menu');
    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].onclick = function (event) {
        for (let j = 0; j < menuLi.length; j++) {
          const parentLi = that.closest(this, 'li');
          if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
            menuLi[j].classList.remove('open')
          }
        }
        this.classList.toggle('open');
      }
    }

    const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
    try {
      const activeNav = this.closest(activeLi, 'ul'); // select closest ul
      if (activeNav.classList.contains('sub-menu')) {
        this.closest(activeNav, 'li').classList.add('open');
      } else {
        this.closest(activeLi, 'li').classList.add('open');
      }
    } catch (error) {

    }
  }

  componentWillReceiveProps(nextProps) {
    const { history } = nextProps;
    const pathname = `${history.location.pathname}`;// get current path

    const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
    try {
      const activeNav = this.closest(activeLi, 'ul'); // select closest ul
      if (activeNav.classList.contains('sub-menu')) {
        this.closest(activeNav, 'li').classList.add('open');
      } else {
        this.closest(activeLi, 'li').classList.add('open');
      }
    } catch (error) {

    }
  }

  closest(el, selector) {
    try {
      let matchesFn;
      // find vendor prefix
      ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
        if (typeof document.body[fn] == 'function') {
          matchesFn = fn;
          return true;
        }
        return false;
      });

      let parent;

      // traverse parents
      while (el) {
        parent = el.parentElement;
        if (parent && parent[matchesFn](selector)) {
          return parent;
        }
        el = parent;
      }
    } catch (e) {

    }

    return null;
  }

  render() {
    return (
      <CustomScrollbars className=" scrollbar">
        <ul className="nav-menu">
          <li className="menu no-arrow mt-4">
            <NavLink className="prepend-icon" to="/app/dashboard">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.dashboard" />
              </span>
            </NavLink>
          </li>
          {/* <li className="menu no-arrow mt-3">
            <NavLink to="/app/myProgress">
              <i className="zmdi zmdi-chart zmdi-hc-fw" />
              <span className="nav-text"><IntlMessages id="sidebar.appModule.myProgress" /></span>
            </NavLink>
          </li> */}
          <li className="menu no-arrow mt-3">
            <NavLink to="/app/players">
              <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
              <span className="nav-text"><IntlMessages id="sidebar.appModule.players" /></span>
            </NavLink>
          </li>
          <li className="menu no-arrow mt-3">
            <NavLink to="/app/coaches">
              <i className="zmdi zmdi-group-work zmdi-hc-fw" />
              <span className="nav-text"><IntlMessages id="sidebar.appModule.coaches" /></span>
            </NavLink>
          </li>
          {/* <li className="menu no-arrow mt-3">
            <NavLink to="/app/mySession/insight">
              <i className="zmdi zmdi-chart-donut zmdi-hc-fw" />
              <span className="nav-text"><IntlMessages id="sidebar.appModule.mySession" /></span>
            </NavLink>
          </li> */}
          {/* <li className="menu no-arrow mt-3">
            <NavLink to="/app/profile">
              <i className="zmdi zmdi-account zmdi-hc-fw" />
              <span className="nav-text"><IntlMessages id="sidebar.appModule.profile" /></span>
            </NavLink>
          </li> */}
        </ul>
      </CustomScrollbars>
    );
  }
}

export default withRouter(SidenavContent);
